import { handleAttachmentPaste } from "@/common/helpers/files";
import { useDragAndDrop } from "@/hooks/dragAndDrop";
import { useChatStyle } from "./style";

export const useMessagingDrop = (
	processFiles: (files: File[]) => void | Promise<void>,
	disabled = false
) => {
	const classes = useChatStyle();
	const { isDragActive, dragProps } = useDragAndDrop({
		onDrop: processFiles,
		disabled,
	});

	const containerProps = {
		...dragProps,
		onPaste: (event: React.ClipboardEvent<HTMLDivElement>) =>
			handleAttachmentPaste(event, !disabled, processFiles),
	};

	return {
		isDragActive,
		containerProps,
		sendboxRelativeClass: classes.sendboxRelative,
	};
};
